import React from 'react';
import { IIcons } from './types';

export const IncidentHoldFlag = ({color = '#566878'}: IIcons) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.4587 11.8513L12.7111 8.88642C12.7168 8.85012 12.7206 8.81312 12.7206 8.77502C12.7206 8.37742 12.3983 8.05512 12.0006 8.05512C11.6031 8.05512 11.2806 8.37742 11.2806 8.77502C11.2806 8.81312 11.2845 8.85012 11.2901 8.88642L11.5424 11.8513C11.5424 12.1043 11.7476 12.3094 12.0006 12.3094C12.2536 12.3094 12.4587 12.1043 12.4587 11.8513Z"
            fill={color}
        />
        <path
            d="M11.346 13.2923C11.346 13.6538 11.639 13.9468 12.0005 13.9468C12.362 13.9468 12.6551 13.6538 12.6551 13.2923C12.6551 12.9308 12.362 12.6378 12.0005 12.6378C11.639 12.6378 11.346 12.9308 11.346 13.2923Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.5258 6.40312L16.8717 14.5419C17.1608 15.0836 16.9447 15.5 16.3912 15.5H7.60842C7.05528 15.5 6.83926 15.0809 7.12833 14.5383L11.4742 6.41075C11.7633 5.8682 12.2368 5.86056 12.5258 6.40312Z"
            fill={color}
        />
    </svg>
);
